import { ClerkProvider } from "@clerk/clerk-react";
import { arSA, enUS } from "@clerk/localizations";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";

import {
  signupAuthStepUrl,
  signupCompanyStepUrl,
  signupSigninStepUrl,
} from "../lib/signup-urls";

type Props = {
  publishableKey: string;
  children: ReactNode;
};

/** Clerk auth UI follows the active i18next locale (EN / AR). */
export function LocalizedClerkProvider({
  publishableKey,
  children,
}: Props) {
  const { i18n } = useTranslation();
  const localization = i18n.language === "ar" ? arSA : enUS;

  return (
    <ClerkProvider
      publishableKey={publishableKey}
      localization={localization}
      signUpUrl={signupAuthStepUrl()}
      signInUrl={signupSigninStepUrl()}
      signUpForceRedirectUrl={signupCompanyStepUrl()}
      signInForceRedirectUrl={signupCompanyStepUrl()}
    >
      {children}
    </ClerkProvider>
  );
}
